"use strict";

import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

import GUI from 'lil-gui';
import Stats from 'stats.js';

import Garden from '../Garden';

class App {

    // Three.js
    scene: THREE.Scene;
    camera: THREE.Camera;
    renderer: THREE.WebGLRenderer;
    clock = new THREE.Clock(true);
    controls: OrbitControls;

    stats = new Stats();

    garden: Garden;

    constructor() {

        document.addEventListener("click", (event) => {
            event.preventDefault();
            let x = (event.clientX / window.innerWidth) * 2 - 1;
            let y = - (event.clientY / window.innerHeight) * 2 + 1;

            this.garden.click({ x, y }, this.camera);
        });

        // Stats
        this.stats.showPanel(0);
        document.body.appendChild(this.stats.dom);

        // Gui
        const gui = new GUI();
        const guiObject = {
            progress: 1,
            ar: () => {
                window.open('/ar/index.html');
            },
            report: () => {
                console.log(this.renderer.info.render);
            },
            generate: () => {
                this.garden.generate();
            },
            capture: async () => {
                let canvas = this.renderer.domElement;

                // Prepare canvas
                this.renderer.setClearColor(0x000000, 0);
                this.resize(4096, 4096);
                await new Promise(r => setTimeout(r, 10));

                // Capture image.
                let imageUrl = canvas.toDataURL();
                console.log(imageUrl);

                // Fake click.
                const anchor = document.createElement('a');
                anchor.download = 'image.png';
                anchor.href = imageUrl;
                anchor.click();
                anchor.remove();

                // Restore canvas.
                this.renderer.setClearColor(0x000000, 1);
                this.resize(window.innerWidth, window.innerHeight);
            }
        };

        gui.add(guiObject, 'progress', 0, 1).onChange(value => {
            this.garden.progress(value);
        });

        gui.add(guiObject, 'ar');
        gui.add(guiObject, 'report');
        gui.add(guiObject, 'generate');
        gui.add(guiObject, 'capture');

        // Three setup.

        this.scene = new THREE.Scene();

        // Perspective camera.
        this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);

        // Orthographic camera.
        // let width = window.innerWidth;
        // let height = window.innerHeight;
        // this.camera = new THREE.OrthographicCamera(width / - 2, width / 2, height / 2, height / - 2, .001, 10000);
        // this.camera.scale.set(.025, .025, .025);

        this.renderer = new THREE.WebGLRenderer({
            "antialias": true,
            "alpha": true,
            "preserveDrawingBuffer": true
        });
        this.renderer.setClearColor(0x000000, 1);


        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        document.body.appendChild(this.renderer.domElement);

        // this.camera.position.set(0, 96, 0); // Capture B
        // this.camera.position.set(0, 72, 0); // Capture A

        // this.controls.target.set(0, 0, 0);
        //this.camera.position.z = 12;

        // this.camera.position.set(0, 14, 0);// Bloom

        // this.camera.position.set(0, 0, 5);// Dome
        this.camera.position.set(0, 0, 2);// Circle

        // this.camera.position.set(0, 0, 2);// Bloom

        // Controls
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        // this.controls.target.set(0, 0, 0);
        this.controls.target.set(0, 0, 0);
        this.controls.update();

        // Garden.
        this.garden = new Garden();
        this.scene.add(this.garden);

        // let circleView = new Garden.Views.GeometryView(
        //     {
        //         modelUrl: new URL("../assets/models/Circle.obj", import.meta.url).toString(),
        //         maxBloomRadius: .20,
        //         minBloomRadius: .08,
        //         minSurfaceOffset: .04,
        //         maxSurfaceOffset: .18,
        //         textureScale: 8
        //     }
        // );
        // this.garden.add(circleView);
        // this.garden.views.push(circleView);

        {
            let domeView = new Garden.Views.GeometryView(
                {
                    modelUrl: new URL("../assets/models/DomeFacade.obj", import.meta.url).toString(),
                    maxBloomRadius: .28,
                    minBloomRadius: .08,
                    minSurfaceOffset: .04,
                    maxSurfaceOffset: .18,
                    textureScale: 12
                }
            );
            this.garden.add(domeView);
            this.garden.views.push(domeView);
        }

        // let bloomView = new Garden.Views.BloomView();
        // this.garden.add(bloomView);
        // this.garden.views.push(bloomView);
        // this.camera.position.set(0, 14, 0);
        // this.controls.target.set(0, 0, 0);

        // Click off animation.
        this.animate();

        window.addEventListener('resize', () => {
            this.resize(window.innerWidth, window.innerHeight);
        });
    }

    resize(width, height) {
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(width, height);
    }

    animate() {

        this.stats.begin();

        this.controls.update();

        this.garden.update();

        this.renderer.render(this.scene, this.camera);

        this.stats.end();

        requestAnimationFrame(this.animate.bind(this));
    };
}

export default new App();